import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { app_main_routing_menu } from '@shared/app-main-routing-menu';
import { map, take } from 'rxjs';
import { UserAuthorizationService } from '@services/user-authorization.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const userAuthorizationService = inject(UserAuthorizationService);

  const isLoginPages = state.url.includes(
    `/${app_main_routing_menu.login.path}`,
  );

  return authService.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      // Authenticated users: redirect away from login pages, allow everything else
      if (isAuthenticated) {
        return isLoginPages
          ? router.parseUrl(
              `/${
                userAuthorizationService.isSuperAdmin ||
                !userAuthorizationService.isMultiTenant
                  ? app_main_routing_menu.audience_manager.path
                  : app_main_routing_menu.switchTenant.path
              }`,
            )
          : true;
      }

      // Unauthenticated users: allow login pages, redirect everything else to login
      if (isLoginPages) {
        return true;
      }

      // Store the attempted URL for post-login redirect
      authService.setReturnUrl(state.url);

      // Redirect to login page (tenant-agnostic SSO initialization)
      return router.parseUrl(`/${app_main_routing_menu.login.path}`);
    }),
  );
};
